/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connect_Claude_TitleInputs */

const en_connect_claude_title = /** @type {(inputs: Connect_Claude_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connect Claude`)
};

/**
* | output |
* | --- |
* | "Connect Claude" |
*
* @param {Connect_Claude_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const connect_claude_title = /** @type {((inputs?: Connect_Claude_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connect_Claude_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_connect_claude_title(inputs)
});